export default "__VITE_ASSET__7634$awK__"